/** Empty /comparison list state layout */
export default function ComparisonListPageSkeleton() {
  return (
    <div className="skeleton-stage p-6 w-full" aria-busy aria-label="Loading">
      <div className="flex flex-col gap-6 bg-white rounded-xl p-6">
        <div className="flex justify-between items-start gap-4">
          <div className="space-y-2">
            <div className="h-8 w-64 max-w-full skeleton-shimmer rounded-md" />
            <div className="h-4 w-80 max-w-full skeleton-shimmer rounded-md" />
          </div>
        </div>
        <div className="h-4 w-full max-w-md skeleton-shimmer rounded-md" />
      </div>
    </div>
  );
}
